<template>
  <div class="content">
    <nav-bar titleText="视频专区" titleWeight="bold" @goBack="closeContractSigned"></nav-bar>
    <van-tabs v-model="id" swipeable @click="clickTab" @change="changeTab" class="tabs" animated>
      <van-tab v-for="(item,index) in tabTitles" :key="'a'+index" :title="item.name.slice(0, 4)" :name="item.id"
        class="van_tab">
        <video-content :id="id"></video-content>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
  import navBar from "./components/navBar";
  import videoContent from "./components/videoContent"
  export default {
    components: {
      navBar,
      videoContent
    },
    data() {
      return {
        id: Number,
        tabTitles: [],
        ios: ''
      }
    },
    created() {
      this.getVideoGroup()
      if (this.$route.query.token) {
        this.$api.setToken(this.$route.query.token);
      }
      this.id = Number(this.$route.query.id)
      this.ios = this.$route.query.ios
      if (this.ios == true || this.ios == 'true') {
        this.closeWeexGesture()
      }
    },
    methods: {
      closeContractSigned() {
        this.params('success', 'success', 'closeContractSigned');
      },
      closeWeexGesture() {
        this.params('', '', 'closeWeexGesture');
      },
      getVideoGroup() {
        this.$api.post('estate/index/video/group/list', {
          status: 1
        }).then(res => {
          this.tabTitles = res.list
        })
      },
      clickTab(id) {
        this.id = id
      },
      changeTab(id) {
        this.id = id
      },
    },
  }
</script>

<style lang="less" scoped>
  .content {
    padding-top: 88px;
    box-sizing: border-box;
    height: 100%;
    font-size: 16px;
    color: #333;
    overflow: hidden;
  }

  .tabs {
    height: 100%;
    overflow: hidden;
  }

  /deep/ .van-tabs__content {
    height: calc(100% - 44px);
    overflow: hidden;
  }

  /deep/ .van-tab__pane {
    height: 100%;
  }

  .van_tab {
    height: 100%;
    overflow: hidden;
  }
</style>